import { useTranslation } from 'react-i18next';
import { post } from '../../utils/api';
import './Translator.css';
//
// Компонент для размещения в поле bottom элементов ввода формы.
// Обеспечивает перевод и установку текста в элемент ввода.
//
// current - текущий текст
// text - текст который переводим
// from - с какого языка переводим ru/en
// limit - ограничение по длине текста
// setText - функция установки текста после перевода
// setIsTranslating - функция установки флага того что идет перевод
const Translator = ({ current, text, from, limit, setText, setIsTranslating }) => {
	const { t } = useTranslation();

    // Перевод текста
    const doTranslate = async (text, from, limit, setText) => {
        setText(t('common.translating'));
        setIsTranslating(true);
        const result = await post('/translate', { text, from });
        if(result.data) {
            setText(result.data.translation.substring(0, limit));
        } else {
            setText(text.substring(0, limit));
        }
        setIsTranslating(false);
    };

    return (
    <div className='Translator'>
        <span>{current ? `${current.length} / ${limit}`: `Max: ${limit}`}</span>
        {text && <span onClick={() => doTranslate(text, from, limit, setText)}>{t(`common.translate_from_${from}`)}</span>}
    </div>
    );
};

export default Translator;
